import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";

const ApproveSPLeave = () => {
  const navigate = useNavigate();
  const [ApproveSpecialLeave, setApproveCompLeave] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [apiStatus, setApiStatus] = useState(undefined)

  const columns = {
    Name: { text: "Employee", visible: "true" },
    FromDate: { text: "From", align: "center", visible: "true" },
    ToDate: { text: "To", align: "center", visible: "true" },
    LeaveName: { text: "Leave Type", align: "center", width: "80px", visible: "true" },
    Purpose: { text: "Details", visible: "true" , width: "140px"},
    TXNDate: { text: "Applied Date", align: "center", visible: "true" },
    ApplicationStatus: { text: "Status", visible: "true" },
    FileName: { text: "Attachment",type:"Link", color:"blue", visible: "true" },
  };
  const defaultColumns = {
    Name: true,
    TXNDate: true,
    Purpose: true,
    ToDate: true,
    FromDate: true,
    Project: true,
    ApplicationStatus: true,
  };

  const fetchSpecialLeave = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(`${API_URL}special-approve-leave`);
      setApiStatus(response?.status)
      if (response.status === 200) {
        const specialLeaveData = response?.data?.header;
        setApproveCompLeave(specialLeaveData);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  useEffect(() => {
    fetchSpecialLeave();
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Approve ML/BL/PL/SL Leave"));
  }, []);

  const [selectedEmployee, setSelectedEmployee] = useState([])
  const handleApproveModel = (id) => {
    setSelectedLeaveId(id.ID);
    setSelectedEmployee(id)
    setShowModal(true);
  };

  const handleRejectModel = (id) => {
    setSelectedLeaveId(id.ID);
    setSelectedEmployee(id)

    setRejectModal(true);
  };
  const handleApprove = (event) => {
    event.preventDefault();
    leaveStatus(826);
  };
  const [remarkValue, setRemarkValue] = useState("");

  const handleReject = (event) => {
    event.preventDefault();
    leaveStatus(827);
  };

  const [modelLoder, setModelLoder] = useState(false)

  const leaveStatus = (status) => {
    setModelLoder(true)
    PostServiceCaller(
      `${API_URL}approve-special-leaves-details/${selectedLeaveId}`,
      {
        leavestatus: status,
        ActionRemarks: remarkValue,
        EmployeeID: selectedEmployee?.EmployeeID,
        LeaveID: selectedEmployee?.LeaveID,
        rowstatus: 436, // Assuming this is a number

      },
      "put"
    )
      .then((response) => {
        if (status === 826) {
          setModelLoder(false)

          toast.success("Special leave Approved Successfully!");
        } else if (status === 827) {
          setModelLoder(false)

          toast.success("Special leave Rejected Successfully!");
        }
        fetchSpecialLeave();
        setShowModal(false);
        setRejectModal(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleView = (id) => {
    navigate(`/special-leave/view/${id.ID}`);
  };

  const handleLinkCOlumn = (columnName, item)=>{
    window.open(item?.FilePath);
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={ApproveSpecialLeave}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              showIcon2={true}
              showIcon3={true}
              isSorting={true}
              hanldeLinkColumn={handleLinkCOlumn}
              isActionRequired={true}
              handleIcon1={handleView}
              handleIcon2={handleApproveModel}
              handleIcon3={handleRejectModel}
              add
              more
              function
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View",
                Icon2: <i className="fa fa-check"></i>,
                Icon2Text: "Approved Special leave",
                Icon2Flag: "canApprove",
                Icon3: <i className="fa fa-close"></i>,
                Icon3Text: "Reject Special leave",
                Icon3Flag: "canReject",
              }}
            />
          </div>
          {/* Approve Form */}
          {showModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050
              }}
            >
              <div className="modal-dialog modal-sm" role="document" style={{
                width: "300px", // Standard width for modal-sm
                margin: 0 // Remove default margin
              }}>
                <div className="modal-content">
                  <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px 8px 0 0'
                  }}>
                    <p style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}>Approve</p>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#000',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s',
                        lineHeight: '1'
                      }}
                      onClick={() => setShowModal(false)}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="modal-body p-2">
                    <form onSubmit={handleApprove}>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            className="form-control"
                            id="Remark"
                            aria-describedby="Remark"
                            name="Remark"
                            onChange={(e) => setRemarkValue(e.target.value)}
                            placeholder="Remark"
                          />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="cancel-btn-sm me-2"
                          onClick={() => setShowModal(false)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="custom-btn-sm">
                          {modelLoder ? <FaSpinner className="spinner-sm" /> : "Approve"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Reject Form */}
          {rejectModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050
              }}
            >
              <div className="modal-dialog modal-sm" role="document" style={{
                width: "300px", // Standard width for modal-sm
                margin: 0 // Remove default margin
              }}>
                <div className="modal-content">
                  <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px 8px 0 0'
                  }}>
                    <p style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}>Reject</p>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#000',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s',
                        lineHeight: '1'
                      }}
                      onClick={() => setRejectModal(false)}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="modal-body p-2">
                    <form onSubmit={handleReject}>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            className="form-control"
                            id="Remark"
                            aria-describedby="Remark"
                            name="Remark"
                            placeholder="Remark"
                          />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="cancel-btn-sm me-2"
                          onClick={() => setRejectModal(false)}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="custom-btn-sm">
                          {modelLoder ? <FaSpinner className="spinner-sm" /> : "Reject"}

                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ApproveSPLeave;